export const CAR_STRUCTURE_TYPE = "רכב" as const;
export const CARS_PATH = "/cars";
export const CARS_BREADCRUMB = { ledger: "כרטסות", list: "רכבים" } as const;
export const CARS_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
